import React from 'react';
import useWindowSize from '../../hooks/useWindowSize';
import ColumnNavBar from './ColumnNavBar';
import RowNavBar from './RowNavBar';
import { NawWrapper } from './SeoNavBar.styles';

const SeoNavBar = () => {
  const { width } = useWindowSize();
  return (
    <NawWrapper>
      {width < 1280 && <ColumnNavBar />}
      {width >= 1280 && <RowNavBar />}
    </NawWrapper>
  );
};

export default SeoNavBar;
